<template>
  <el-row>
    <el-col :span="24">
      <el-card v-loading="loading">
        <div slot="header" class="flex-space-between">
          <span class="title">Opportunities</span>
          <div>
            <el-tooltip content="Insert" placement="top">
              <el-button
                type="success"
                circle
                icon="el-icon-plus"
                @click.prevent="insert()"
              ></el-button>
            </el-tooltip>
            <Dialog />
          </div>
        </div>
        <Table />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Table from '../components/opportunities/Table'
import Dialog from '../components/opportunities/Dialog'
import { mapState, mapMutations } from 'vuex'

export default {
  components: {
    Table,
    Dialog
  },

  computed: {
    ...mapState('opportunityCarousel', ['loading'])
  },

  methods: {
    ...mapMutations('opportunityCarousel', [
      'setDialog',
      'setSelectedOpportunity'
    ]),
    initialOpportunity() {
      return {
        id: null,
        title: null,
        quote: null,
        post_link: null,
        position: null
      }
    },
    insert() {
      this.setDialog(true)
      this.setSelectedOpportunity(this.initialOpportunity())
    }
  }
}
</script>
